import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Field } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import { Link, useLocation } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

import { Grid } from "@material-ui/core";
import {
  Title,
  Text,
  Margin,
  Input,
  Button,
  Select,
  Checkbox,
  Message,
  ErrorMessage,
  Loading,
} from "~/components/elements";
import { schema } from "./validation";
import { Creators as SignUpActions } from "~/store/modules/signUp/actions";
import { Creators as PromoActions } from "~/store/modules/promo/actions";
import { cpfMask, phoneWithoutDDDMask, dddMask } from "~/utils/tools";
import { ufSelect, phoneTypeSelect } from "~/utils/variables";
import isMobile from "~/hooks/isMobile";

import * as S from "./styles";

export default function FormSignUpComplement() {
  const mobile = isMobile();
  const location = useLocation();
  const [captchaTrue, setCaptcha] = useState(false);
  const dispatch = useDispatch();
  // const [cepNotFound, setCepNotFound] = useState(false);
  // const [loadingCep, setLoadingCep] = useState(false);
  const sending = useSelector((state) => state?.signUp?.sign?.sending);
  const errorMessage = useSelector(
    (state) => state?.signUp?.sign?.errorMessage
  );
  // const errorZipCodeMessage = useSelector(
  //   (state) => state?.account?.zipCode?.errorMessage
  // );

  const address = useSelector((state) => state?.account?.zipCode?.address);
  const documentoViewValue = useSelector(
    (state) => state?.authentication?.auth?.user?.DocumentoView
  );
  const documentoView = !!documentoViewValue;
  const DocumentoCrip = useSelector(
    (state) => state?.authentication?.auth?.user?.DocumentoCrip
  );
  const initialValues = {
    ParticipanteHash: useSelector(
      (state) => state?.authentication?.auth?.user?.ParticipanteHash
    ),
    DocumentoCrip: DocumentoCrip,
    CPFView: documentoView,
    Email: useSelector((state) => state?.authentication?.auth?.user?.email),
    DDDTelefone: "",
    Telefone: "",
    TelefoneTipo: phoneTypeSelect[0],
    Estado: ufSelect[0],
    // Cidade: "",
    // Cep: "",
    // Endereco: "",
    // Numero: "",
    // Complemento: "",
    AceitaRegulamento: 0,
    AceitaReceberNoticias: 0,
    AceitaPoliticaDePrivacidade: 0,
    AceitaTermosLegais: 0,
  };

  const url = process.env.REACT_APP_HOST_URL;
  const origin = process.env.REACT_APP_ORIGIN;

  useEffect(() => {
    dispatch(SignUpActions.setSignUpData());
  }, [dispatch]);

  const getUF = (uf) => {
    if (!uf) return ufSelect[0];
    return ufSelect?.find((data) => data.value === uf);
  };

  return (
    <S.FormHolder>
      <Margin mt={6} mb={3}>
        <Title as="2" level="6" primary>
          <strong>Dados pessoais</strong>
        </Title>
      </Margin>
      <Margin mb={3}>
        <Formik
          initialValues={initialValues}
          validationSchema={schema}
          onSubmit={(values, { setSubmitting }) => {
            setSubmitting(false);
            dispatch(SignUpActions.setSignUpData());
            const payloadValues = {
              ...values,
              TipoDocumento: 0,
              AceitaReceberNoticias:
                values.AceitaReceberNoticias &&
                values.AceitaReceberNoticias.length > 0
                  ? true
                  : false,
              AceitaTermosLegais:
                values.AceitaTermosLegais &&
                values.AceitaTermosLegais.length > 0
                  ? true
                  : false,
              AceitaRegulamento:
                values.AceitaRegulamento && values.AceitaRegulamento.length > 0
                  ? true
                  : false,
              Estado: values.Estado.value,
              DddResidencial:
                values.TelefoneTipo?.value === "1" ? values.DDDTelefone : "",
              TelResidencial:
                values.TelefoneTipo?.value === "1" ? values.Telefone : "",
              DddComercial:
                values.TelefoneTipo?.value === "2" ? values.DDDTelefone : "",
              TelComercial:
                values.TelefoneTipo?.value === "2" ? values.Telefone : "",
              DddCelular:
                values.TelefoneTipo?.value === "3" ? values.DDDTelefone : "",
              TelCelular:
                values.TelefoneTipo?.value === "3" ? values.Telefone : "",
              // Cep: values.Cep,
              // Endereco: values.Endereco,
              // Numero: values.Numero,
              // Complemento: values.Complemento,
              Url: url,
              Origin: origin,
            };
            delete payloadValues.AceitaPoliticaDePrivacidade;
            delete payloadValues.CPFView;
            DocumentoCrip === null && delete payloadValues.DocumentoCrip;

            if (initialValues.ParticipanteHash) {
              dispatch(PromoActions.setRegisterStep(2));
              dispatch(SignUpActions.sendSignUpForm(payloadValues));
            }
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            isValid,
            dirty,
          }) => (
            <S.FormLimiter onSubmit={handleSubmit}>
              <S.GridHolder>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Margin mb={mobile ? 8 : 4}>
                      {documentoView ? (
                        <Input
                          label="CPF"
                          htmlFor="CPFViewFieldFormSignup"
                          name="CPFView"
                          value={documentoViewValue}
                          valid={true}
                          disabled
                        />
                      ) : (
                        <Input
                          mask={cpfMask}
                          label="CPF"
                          placeholder="Digite seu CPF"
                          htmlFor="cpfFieldFormRegister"
                          name="Documento"
                          value={values.Documento}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          errors={touched.Documento && errors.Documento}
                          valid={!errors.Documento && touched.Documento}
                          required
                        />
                      )}
                    </Margin>
                  </Grid>
                </Grid>
              </S.GridHolder>
              <Margin mb={mobile ? 3 : 2}>
                <Title
                  as="2"
                  levelDesktop="6"
                  level="6"
                  primary
                  emphasis={false}
                >
                  <strong>Informações de contato</strong>
                </Title>
              </Margin>
              <Grid container>
                <Grid item xs={12} md={12}>
                  <Margin mb={3} mt={mobile ? 5 : 0}>
                    <Select
                      label="Estado"
                      name="Estado"
                      placeholder="UF"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={address.uf ? getUF(address.uf) : values.Estado}
                      errors={touched.Estado && errors.Estado}
                      valid={!errors.Estado}
                      options={ufSelect}
                      required
                      id="stateFieldFormSignup"
                    />
                  </Margin>
                </Grid>
              </Grid>

              <Grid container>
                <Grid item xs={12} md={2}>
                  <Margin mb={mobile ? 3 : 4} mr={mobile ? 0 : 2}>
                    <Input
                      mask={dddMask}
                      placeholder="DDD"
                      htmlFor="phonedddFieldFormSignup"
                      name="DDDTelefone"
                      value={values.DDDTelefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.DDDTelefone && errors.DDDTelefone}
                      valid={!errors.DDDTelefone}
                    />
                  </Margin>
                </Grid>
                <Grid item xs={12} md={5}>
                  <Margin mb={mobile ? 3 : 4} mr={mobile ? 0 : 2}>
                    <Input
                      mask={phoneWithoutDDDMask}
                      placeholder="00000-0000"
                      htmlFor="phoneFieldFormSignup"
                      name="Telefone"
                      value={values.Telefone}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      errors={touched.Telefone && errors.Telefone}
                      valid={!errors.Telefone}
                    />
                  </Margin>
                </Grid>

                <Grid item xs={12} md={5}>
                  <Margin mb={mobile ? 3 : 4}>
                    <Select
                      name="TelefoneTipo"
                      placeholder="Residencial"
                      onChange={setFieldValue}
                      onBlur={handleBlur}
                      value={values.TelefoneTipo}
                      errors={touched.TelefoneTipo && errors.TelefoneTipo}
                      valid={!errors.TelefoneTipo}
                      options={phoneTypeSelect}
                      id="phoneTypeFieldFormSignup"
                    />
                  </Margin>
                </Grid>
              </Grid>
              <Margin mt={3} mb={mobile ? 3 : 4}>
                <S.TermsHolder>
                  <Margin mb={4}>
                    <Title level="6" primary>
                      <strong>Termos de aceite</strong>
                    </Title>
                  </Margin>
                  <Margin mb={2}>
                    <S.LabelRadio
                      error={
                        errors.AceitaPoliticaDePrivacidade &&
                        errors.AceitaPoliticaDePrivacidade.length < 50
                      }
                    >
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        name="AceitaPoliticaDePrivacidade"
                        value="1"
                        id="privacityCheckFormSignup"
                      />
                      <Text level="2">
                        Li e concordo com a{" "}
                        <HashLink
                          to="/politica-de-privacidade#conteudo"
                          target="_blank"
                        >
                          Política de Privacidade.
                        </HashLink>
                      </Text>
                    </S.LabelRadio>

                    {errors.AceitaPoliticaDePrivacidade &&
                      errors.AceitaPoliticaDePrivacidade.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaPoliticaDePrivacidade}
                        </Message>
                      )}
                  </Margin>

                  <Margin mb={2}>
                    <S.LabelRadio
                      error={
                        errors.AceitaRegulamento &&
                        errors.AceitaRegulamento.length < 50
                      }
                    >
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaRegulamento"
                        value="1"
                        id="regulamentCheckFormSignup"
                        valid={
                          errors.AceitaRegulamento && touched.AceitaRegulamento
                        }
                      />
                      <Text level="2">
                        Li e concordo com o{" "}
                        <Link
                          to={`/regulamento#conteudo${location.search}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Regulamento.
                        </Link>
                      </Text>
                    </S.LabelRadio>
                    {errors.AceitaRegulamento &&
                      errors.AceitaRegulamento.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaRegulamento}
                        </Message>
                      )}
                  </Margin>

                  <Margin mb={2}>
                    <S.LabelRadio>
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaReceberNoticias"
                        value="1"
                        id="newsCheckFormSignup"
                      />
                      <Text level="2">
                        Aceito receber comunicações personalizadas.
                      </Text>
                    </S.LabelRadio>
                  </Margin>

                  <Margin mb={2}>
                    <S.LabelRadio
                      error={
                        errors.AceitaTermosLegais &&
                        errors.AceitaTermosLegais.length < 50
                      }
                    >
                      <Field
                        component={Checkbox}
                        type="checkbox"
                        name="AceitaTermosLegais"
                        value="1"
                        id="legalCheckFormSignup"
                      />
                      <Text level="2">
                        Li e concordo com os{" "}
                        <HashLink
                          smooth
                          target="_blank"
                          to="/informacoes-legais#conteudo"
                        >
                          Termos legais.
                        </HashLink>
                      </Text>
                    </S.LabelRadio>
                    {errors.AceitaTermosLegais &&
                      errors.AceitaTermosLegais.length < 50 && (
                        <Message variant="error">
                          {errors.AceitaTermosLegais}
                        </Message>
                      )}
                  </Margin>
                </S.TermsHolder>
              </Margin>
              <Margin mb={mobile ? 3 : 4}>
                <S.CaptchaHolder>
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_RECAPTCHA_KEY}
                    onChange={setCaptcha}
                  />
                </S.CaptchaHolder>
              </Margin>
              <S.ButtonsGrid
                container
                justifyContent="space-between"
                direction={mobile ? "column-reverse" : "row"}
              >
                <Margin mb={mobile ? 3 : 0}>
                  <Button
                    className="animation-size"
                    color={
                      !isValid || !dirty || !captchaTrue || sending
                        ? "disabled"
                        : "primary"
                    }
                    disabled={!isValid || !dirty || !captchaTrue || sending}
                    type="submit"
                    id="nextButtonFormSignup"
                  >
                    {sending ? <Loading button /> : "AVANÇAR >"}
                  </Button>
                </Margin>
              </S.ButtonsGrid>
              {errorMessage && (
                <Margin mt={mobile ? 3 : 5}>
                  <ErrorMessage>{errorMessage}</ErrorMessage>
                </Margin>
              )}
            </S.FormLimiter>
          )}
        </Formik>
      </Margin>
    </S.FormHolder>
  );
}
